module.exports = __webpack_public_path__ + "img/logo.e174fed4.png";